import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LogOut, LayoutDashboard, ShieldCheck, Bell } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useInbox } from '../context/InboxContext';

const AdminBar = () => {
  const { isAdmin, user, logout } = useAuth();
  const { summary } = useInbox();
  const location = useLocation();

  if (!isAdmin) return null;

  const unread = summary.total || 0;
  // Compact breakdown for the tooltip: "2 prayer requests · 1 hall rental"
  const parts = [];
  if (summary.registrations) parts.push(`${summary.registrations} registration${summary.registrations === 1 ? '' : 's'}`);
  if (summary.prayers) parts.push(`${summary.prayers} prayer request${summary.prayers === 1 ? '' : 's'}`);
  if (summary.contacts) parts.push(`${summary.contacts} message${summary.contacts === 1 ? '' : 's'}`);
  if (summary.hall_rentals) parts.push(`${summary.hall_rentals} hall rental${summary.hall_rentals === 1 ? '' : 's'}`);
  const tooltip = unread ? `New: ${parts.join(' · ')}` : 'No new requests';

  return (
    <div className="sticky top-0 z-[60] bg-[#3a2359] text-[#f2ead6] text-xs">
      <div className="max-w-7xl mx-auto px-6 py-2 flex items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <ShieldCheck size={14} className="text-[#e6d4a8]" />
          <span className="tracking-wider uppercase">Admin Mode</span>
          <span className="text-[#c0b58f] hidden sm:inline">— signed in as {user?.username}</span>
        </div>
        <div className="flex items-center gap-4">
          <Link
            to="/admin"
            title={tooltip}
            data-testid="admin-inbox-badge"
            className={`relative inline-flex items-center gap-1.5 hover:text-white ${unread ? '' : 'opacity-60'}`}
          >
            <Bell size={14} className={unread ? 'animate-pulse' : ''} />
            <span className="hidden sm:inline">
              {unread > 0 ? (
                <>
                  <span className="font-semibold text-white">{unread}</span>{' '}
                  <span className="text-[#e6d4a8]">new {unread === 1 ? 'request' : 'requests'}</span>
                </>
              ) : 'Inbox'}
            </span>
            {unread > 0 && (
              <span
                className="absolute -top-1 -right-2 sm:static sm:ml-1 inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full bg-[#e14b3a] text-white text-[10px] font-bold shadow"
                data-testid="admin-inbox-count"
              >
                {unread > 99 ? '99+' : unread}
              </span>
            )}
          </Link>
          {location.pathname !== '/admin' && (
            <Link to="/admin" className="inline-flex items-center gap-1.5 hover:text-white">
              <LayoutDashboard size={14} /> Dashboard
            </Link>
          )}
          <button onClick={logout} className="inline-flex items-center gap-1.5 hover:text-white">
            <LogOut size={14} /> Sign out
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminBar;
